import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { GetjazzmoComponent } from './getjazzmo.component';

@NgModule({
  declarations: [GetjazzmoComponent],
  imports: [SharedModule],
  exports: [GetjazzmoComponent],
})
export class GetjazzmoModule {}
